var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopySection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_8784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35 5.89935V7.64935M8.35 7.64935V9.39935M8.35 7.64935C8.35 7.64935 7.28342 7.64935 6.6 7.64935M8.35 7.64935H10.1M10.38 14.5092H3.86973C3.09653 14.5092 2.46973 13.8824 2.46973 13.1092V4.63918M9.02087 1.69922H5.54986C4.96996 1.69922 4.49986 2.16932 4.49986 2.74922V12.3492C4.49986 12.4597 4.58941 12.5492 4.69986 12.5492H12.3399C12.9198 12.5492 13.3899 12.0791 13.3899 11.4992V6.06821C13.3899 6.04965 13.3825 6.03184 13.3694 6.01872L9.07037 1.71972C9.05724 1.70659 9.03943 1.69922 9.02087 1.69922Z",
    stroke: "#4D4745",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_8784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySection);
export default __webpack_public_path__ + "static/media/copySection.fb172211c8b34b0478b106ff54e16800.svg";
export { ForwardRef as ReactComponent };